export const awaitingClientAgeThreshold = 3 * 24 * 3600 * 1000; // tslint:disable-line:no-magic-numbers
export const responseReceivedAgeThreshold = 24 * 3600 * 1000; // tslint:disable-line:no-magic-numbers
